import React from 'react';
import Header from "../../common/header/header";
import Block1 from "../../common/block1/block1";
import Block2 from "../../common/block2/block2";
import Block3 from "../../common/block3/block3";
import Block4 from "../../common/block4/block4";
import Block5 from "../../common/block5/block5";
import Map from "../../common/map/map"
import Footer from "../../common/footer/footer";

const Main = () => {
    const [selectedCategoryId, setSelectedCategoryId] = React.useState('head');

    React.useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const service = params.get('service');
        if (service) {
            setSelectedCategoryId(service);
        }
    }, []);

    const handleServiceClick = (categoryId) => {
        setSelectedCategoryId(categoryId);
        const priceBlock = document.getElementById('prices');
        if (priceBlock) {
            priceBlock.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <div>
            <Header onServiceClick={handleServiceClick} />
            <Block1 />
            <Block2
                activeCategoryId={selectedCategoryId}
                onCategoryChange={setSelectedCategoryId}
            />
            <Block3 />
            <Block4 />
            <Block5 />
            <Map/>
            <Footer/>
        </div>
    );
};

export default Main;